/** Exibição do cliente no Board: fantasia primeiro, senão razão social (TB01008_NOME). */

export function getBoardClienteExibicao(ordem) {
  if (!ordem || typeof ordem !== 'object') return '';
  const fantVal = ordem.TB01008_FANTASIA ?? ordem.tb01008_fantasia;
  const fant = fantVal != null ? String(fantVal).trim() : '';
  if (fant) return fant;
  const nomeVal = ordem.TB01008_NOME ?? ordem.tb01008_nome;
  const nome = nomeVal != null ? String(nomeVal).trim() : '';
  if (nome) return nome;
  return ordem.cliente != null ? String(ordem.cliente).trim() : '';
}

/** Tooltip: sempre razão social (TB01008_NOME); fallback para o texto exibido. */
export function getBoardClienteTooltipNome(ordem) {
  if (!ordem || typeof ordem !== 'object') return '';
  const nomeVal = ordem.TB01008_NOME ?? ordem.tb01008_nome;
  const nome = nomeVal != null ? String(nomeVal).trim() : '';
  return nome || getBoardClienteExibicao(ordem);
}
